<script>
import { useUserStore } from '@/stores/UserStore'

export default {
  name: 'TooltipCopy',

  props: ['dataCopy'],
  data() {
    return {
      showCopied: false,
    }
  },
  setup() {
    return {
      userStore: useUserStore(),
    }
  },
  methods: {
    copyData(token) {
      try {
        navigator.clipboard.writeText(token)
        this.showCopied = true

        clearTimeout(this.copiedTooltipTimeout)
        this.copiedTooltipTimeout = setTimeout(
          () => (this.showCopied = false),
          1000
        )
      } catch (e) {
        this.showCopied = false
      }
    },
  },
}
</script>

<template>
  <div>
    <v-tooltip v-model="showCopied" top :open-on-hover="false">
      <template v-slot:activator="{ on, attrs }">
        <div v-bind="attrs" class="token" v-on="on" @click="copyData(dataCopy)">
          {{ dataCopy }}
          <v-icon>mdi-content-copy</v-icon>
        </div>
      </template>
      <span>Copied!</span>
    </v-tooltip>
  </div>
</template>
<style scoped>
.token {
  background: #d7e0e3;
  padding: 1rem;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  width: 600px;
}
</style>
